import { Environment } from '~~/app/enum/env'

export const useEnvironment = () => {
  const config = useRuntimeConfig()

  const env = config.public.environment as Environment

  return {
    isProduction: env === Environment.Production,
    isDevelopment: env === Environment.Development,
  }
}
